module.exports = __webpack_public_path__ + "media/images/favicons/apple-icon-114x114-e7e11b3e7dc7067ffe8e01aebf993329.png";